import { GeneralConfigurationContext } from "features/configuration/GeneralConfiguration/generalConfigurationContexts";
import Space from "antd/es/space";
import useSharedGeneralConfiguration from "@shared/features/configuration/useSharedGeneralConfiguration";
import { ConfigurationItem } from "features/configuration/GeneralConfiguration/ConfigurationItem";
import FormItem from "features/configuration/GeneralConfiguration/FormItem/FormItem";
import { UseGeneralConfigurationProps } from "@shared/features/configuration/types";

const useGeneralConfiguration = ({
  configuration,
  editable = true,
  showOverrides = true,
  colorModifiedValues = true,
  precisionConfig,
  extraParams,
  spacing,
  extraInfoAlignRight = true,
  useCard = true,
  useSimpleLayout = false,
  addEditWarningMessage = false,
  isForm,
  orderType,
  useDefaultPopupContainer,
}: UseGeneralConfigurationProps) => {
  const {
    getItemValueByName,
    getItemShouldDisplay,
    toggleItemModified,
    uuidToOriginalItem,
    idToItem,
    getItemByName,
    modifiedConfiguration,
    itemsModified,
    setItemsModified,
    cancelChanges,
    configurationId,
    children,
    clonedConfiguration,
    updateConfiguration,
  } = useSharedGeneralConfiguration({
    configurationItem: configuration,
  });

  const configurationComponent = (
    <GeneralConfigurationContext.Provider
      value={{
        uuidToOriginalItem,
        idToItem,
        toggleItemModified,
        editable,
        showOverrides,
        colorModifiedValues,
        precisionConfig,
        extraParams,
        extraInfoAlignRight,
        useCard,
        useSimpleLayout,
        getItemByName,
        addEditWarningMessage,
        useDefaultPopupContainer,
      }}
    >
      <Space
        size={spacing || 0}
        orientation="vertical"
        style={{ width: "100%" }}
      >
        {children.map((item, index) =>
          isForm ? (
            <FormItem
              key={`${configurationId}_${index}`}
              item={item}
              orderType={orderType}
            />
          ) : (
            <ConfigurationItem
              key={`${configurationId}_${index}`}
              item={item}
              extraInfoAlignRight={extraInfoAlignRight}
            />
          )
        )}
      </Space>
    </GeneralConfigurationContext.Provider>
  );

  return {
    cancelChanges,
    generalConfiguration: configurationComponent,
    modifiedConfiguration,
    itemsModified,
    setItemsModified,
    configurationModified: itemsModified.length > 0,
    getItemValueByName,
    getItemByName,
    getItemShouldDisplay,
    configurationId,
    clonedConfiguration,
    updateConfiguration,
  };
};

export default useGeneralConfiguration;
